// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_angular-animate_index_js-node_modules_angular-route_index_js-node_module-4b870c"], () => (__webpack_require__("./src/index.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
